<template>
  <div>
    <static-loading-indicator-icon :with-card="true"/>

    <div v-if="!$store.getters.isExecutingRequest">
      <div class="card shadow-sm" v-if="errorOccured">
        <div class="card-body">
          <div class="row">
            <div class="col-md-8">
              <p v-html="$t('pages.subscription.status_subscription_error')"></p>

              <button class="btn btn-primary" @click="getSubscriptionStatus">
                {{ $t('pages.subscription.status_button_reload') }}
              </button>
            </div>
            <div class="col-md-4 text-right">
              <i class="mdi mdi-48px text-danger mdi-account-question"></i>
            </div>
          </div>
        </div>
      </div>

      <div v-else>
        <div class="card shadow-sm" v-if="!isSubscribed && status !== 'past_due'" >
          <div class="card-body" >
            <div class="row">
              <div class="col-md-8">
                <p v-html="$t('pages.subscription.status_not_subscribed')"></p>
                <p v-html="$t('pages.subscription.subscribe_now')"></p>

                <button class="btn btn-primary" @click="$router.push({name: 'start-subscription'})">
                  {{ $t('pages.subscription.start_subscription_button') }}
                </button>
              </div>
              <div class="col-md-4 text-right">
                <i class="mdi mdi-48px text-danger mdi-account-remove"></i>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="isSubscribed && status && status !== 'canceled'">
          <div class="card shadow-sm">
            <div class="card-body">
              <h4 class="card-title mb-3">{{ $t('pages.subscription.title') }}</h4>
              <div class="row">
                <div class="col-md-10">
                  <div v-if="!onGracePeriod">
                    <p v-html="$t('pages.subscription.status_subscribed')" class="mb-0"></p>
                    <p v-html="$t('pages.subscription.will_be_renewed', {price: renewalPrice, date: $date(willBeRenewedAt).format('DD.MM.YYYY')})"></p>

                    <div v-if="(monthsPaid < monthsRequiredForDowngrade) && monthsPaid > 0" class="alert alert-secondary border-dark rounded">
                      <p v-html="$t('pages.subscription.time_until_downgrade')"></p>

                      <div class="progress" style="height: 30px;">
                        <div class="progress-bar bg-primary progress-bar-striped progress-bar-animated" role="progressbar"
                             :style="'width: ' + percentageOfMonthsForDowngrade + '%' " :aria-valuenow="percentageOfMonthsForDowngrade" aria-valuemin="0"
                             aria-valuemax="100">
                          {{ monthsPaid }} / {{ monthsRequiredForDowngrade }} {{ $t('pages.subscription.months') }}
                        </div>
                      </div>
                    </div>
                    <div v-else-if="monthsPaid >= monthsRequiredForDowngrade" class="alert alert-secondary border-dark rounded pb-0">
                      <i class="mdi mdi-emoticon-happy-outline mdi-48px text-primary"></i>
                      <p v-html="$t('pages.subscription.downgraded_info')"></p>
                    </div>

                    <div class="mt-5">
                      <hr>
                      <a class="text-muted cursor-pointer font-weight-light" @click="$router.push({name: 'cancel-subscription'})">
                        {{ $t('pages.subscription.cancel_subscription') }}
                      </a>
                      <a class="text-muted cursor-pointer font-weight-light ml-5" @click="$router.push({name: 'update-subscription'})">
                            {{ $t('pages.subscription.error.update') }}
                      </a>
                    </div>
                  </div>
                  <div v-else-if="onGracePeriod">
                    <p v-html="$t('pages.subscription.is_canceled', {date: $date(this.willBeRenewedAt).format('DD.MM.YYYY')})"></p>

                    <button class="btn btn-outline-primary mt-4" @click="$router.push({name: 'resume-subscription'})">
                      {{ $t('pages.subscription.resume_subscription') }}
                    </button>
                  </div>
                </div>
                <div class="col-md-2 text-center">
                  <i class="mdi mdi-96px mdi-check-decagram" :class="[onGracePeriod ? 'text-warning' : 'text-primary']"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="!isSubscribed && (status === 'past_due' || status === 'incomplete' )">
          <div class="card shadow-sm">
            <div class="card-body">
              <h4 class="card-title mb-3">{{ $t('pages.subscription.title') }}</h4>
              <div class="row">
                <div class="col-md-10">
                  <div>
                    <p v-html="$t('pages.subscription.status_subscribed')" class="mb-0"></p>

                    <div v-if="(monthsPaid < monthsRequiredForDowngrade) && monthsPaid > 0" class="alert alert-secondary border-dark rounded">
                      <p v-html="$t('pages.subscription.time_until_downgrade')"></p>

                      <div class="progress" style="height: 30px;">
                        <div class="progress-bar bg-primary progress-bar-striped progress-bar-animated" role="progressbar"
                             :style="'width: ' + percentageOfMonthsForDowngrade + '%' " :aria-valuenow="percentageOfMonthsForDowngrade" aria-valuemin="0"
                             aria-valuemax="100">
                          {{ monthsPaid }} / {{ monthsRequiredForDowngrade }} {{ $t('pages.subscription.months') }}
                        </div>
                      </div>
                    </div>
                    <div v-else-if="monthsPaid >= monthsRequiredForDowngrade" class="alert alert-secondary border-dark rounded pb-0">
                      <i class="mdi mdi-emoticon-happy-outline mdi-48px text-primary"></i>
                      <p v-html="$t('pages.subscription.downgraded_info')"></p>
                    </div>

                    <div class="row align-items-center">
                      <div class="col-md-2">
                        <i class="mdi mdi-96px mdi-alert-decagram text-danger"></i>
                      </div>
                      <p class="col"> {{ $t('pages.subscription.error.text') }}</p>
                    </div>
                    <button class="btn btn-outline-danger mt-4" @click="$router.push({name: 'update-subscription'})">
                      {{ $t('pages.subscription.error.update') }}
                    </button>
                    <div class="mt-5">
                      <hr>
                      <a class="text-muted cursor-pointer font-weight-light" @click="$router.push({name: 'cancel-subscription'})">
                        {{ $t('pages.subscription.cancel_subscription') }}
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-md-2 text-center">
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4" v-if="invoices.length">
          <div class="col-md-12">
            <div class="card shadow-sm">
              <div class="card-body">
                <h4 class="card-title mb-3">{{ $t('pages.subscription.invoices.title') }}</h4>

                <div class="table-responsive">
                  <table class="table table-striped table-borderless">
                    <thead>
                    <tr>
                      <th>{{ $t('pages.subscription.invoices.date') }}</th>
                      <th>{{ $t('pages.subscription.invoices.total') }}</th>
                      <th>{{ $t('pages.subscription.invoices.status') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="invoice in invoices">
                      <td>{{ $date(invoice.date).format('DD.MM.YYYY') }}</td>
                      <td>{{ parseFloat(invoice.total / 100).toFixed(2).replace('.', ',') }}€</td>
                      <td>
                                                <span class="badge badge-success" v-if="invoice.paid">
                                                    {{ $t('pages.subscription.invoices.status_paid') }}
                                                </span>
                        <span class="badge badge-danger" v-else>
                                                    {{ $t('pages.subscription.invoices.status_not_paid') }}
                                                </span>
                      </td>
                      <td class="text-right">
                        <a class="btn btn-outline-dark" :href="'/subscription/invoice/' + invoice.id + '/download'">
                          {{ $t('pages.subscription.invoices.download') }}
                        </a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubscriptionRepository from "../../../../repositories/Subscription/SubscriptionRepository";
import LoadingIndicator from "../../../Includes/LoadingIndicator";
import PageHeader from "../../../Includes/PageHeader";
import StaticLoadingIndicatorIcon from "../../../Includes/StaticLoadingIndicatorIcon";

export default {
  name: "SubscriptionStatusPage",
  components: {StaticLoadingIndicatorIcon, PageHeader, LoadingIndicator},
  data: () => ({
    isSubscribed: false,

    errorOccured: false,

    subscribedAt: null,
    onGracePeriod: false,
    endsAt: null,
    willBeRenewedAt: null,
    renewalPrice: '',
    monthsPaid: 0,
    payment: null,
    status: null,

    invoices: []
  }),
  computed: {
    monthsRequiredForDowngrade() {
      return 12;
    },
    percentageOfMonthsForDowngrade() {
      return (this.monthsPaid / this.monthsRequiredForDowngrade) * 100;
    }
  },
  mounted() {
    this.getSubscriptionStatus();
    this.getInvoices();

    if (typeof this.$route.query.stripe_payment_handled !== 'undefined') {
      this.$snotify.success(this.$t('pages.subscription.start.billing.subscription_successful'));
    }
  },
  methods: {
    downloadInvoice(id) {
      return SubscriptionRepository
          .downloadInvoice(id);
    },
    getSubscriptionStatus() {
      SubscriptionRepository
          .getStatus()
          .then((res) => {
            this.isSubscribed = res.data.active;

            this.subscribedAt = res.data.subscribed_at;
            this.onGracePeriod = res.data.on_grace_period;
            this.endsAt = res.data.ends_at;
            this.willBeRenewedAt = res.data.will_be_renewed_at;
            this.renewalPrice = res.data.renewal_price;
            this.monthsPaid = res.data.months_paid;
            this.payment = res.data.payment_status
            this.status = res.data.status

            this.errorOccured = false;
          }).catch((err) => {
        this.errorOccured = true;
      });
    },
    getInvoices() {
      SubscriptionRepository
          .getInvoices()
          .then((res) => this.invoices = res.data);
    }
  }
}
</script>

<style scoped>

</style>
